export default {
	cixiangweibitianxiang: '此项为必填项',
	dengluyihuode: '登录以获得更无缝的流程。',
	haimeiyouzhanghu: '还没有账号？',
	lijizhuce: '立即注册',
	xuanzebeishiwei: '选择该选项后，您将被视为已同意',
	tiaokuan: '条款和条件',
	yinsishengming: '隐私声明',
	yiji: '以及',
	huo: '或',
	dianziyoujian: '电子邮件',
	mima: '密码',
	dengru: '登录',
	qudenglu: '去登录',
	zhuce: '注册',
	zhucechenggong: '注册成功',
	buyizhi: '不一致',
	meiyoushoudao: '没有收到你的电子邮件验证？',
	yikerenshenfen: '以客人身份继续',
	wangjimima: '忘记密码',
	zhanghao: '账号',
	yanzhengzhanghao: '验证账号',
	yanzhengmima: '验证密码',
	youketishi: '继续作为客人，即表示您同意本网站的条款、数据政策和Cookie政策',
	chakan: '查看',
	xuanzeriqi: '选择日期',
	chufariqi: '出发日期',
	huichengriqi: '回程日期',
	chongshe: '重设',
	queren: '确认',
	genggairiqi: '更改日期',
	hangban: '航班',
	yingfuzonge: '应付总额',
	genggai: '更改',
	xianyoufujai: '现有附加服务',
	xinhangban: '新航班',
	zhifu: '支付',
	daojishi: '支付倒计时',
	zuoweiyiyuding: '抱歉，这个座位已被预订，请选择其他座位。',
	tianjiadaoyuding: '添加到预订',
	ewaituibukongjian: '额外腿部空间，第10行，C座位',
	xinyongka: '信用卡',
	denglushiyongfacebook: '使用FaceBook登录',
	jiazaizhong: '加载中',
	denglushibai: '登录失败!',
	zhuceshibai: '注册失败!',
	liru: '例如',
	dengluchenggong: '登录成功',
};
